import { render, staticRenderFns } from "./ClosedDays.vue?vue&type=template&id=196338ce&scoped=true"
import script from "./ClosedDays.vue?vue&type=script&lang=js"
export * from "./ClosedDays.vue?vue&type=script&lang=js"
import style0 from "./ClosedDays.vue?vue&type=style&index=0&id=196338ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196338ce",
  null
  
)

export default component.exports